import { TSize } from '@roller/rdl/design/types';

/** IFusionAuthTokenDTO - Guest account authentication JWT */
export interface IGuestAuthJwt {
  userId?: string;
  email?: string;
  token: string;
  expiry: string;
  mobile?: string;
}

/** LoginDTO - payload sent with login and signup uuid requests */
export interface IGuestAuthPayload {
  keyword: string;
  type: ECheckoutUserLoginType;
  callingCode?: string;
  socialProvider?: ECheckoutUserIdentityProvider;
  socialCode?: string;
  socialRedirectUri?: string;
  recaptchaJwt?: string;
}

export interface IKnownGuestData {
  mobile?: string;
  email?: string;
}

/** Roller.Core.Domain.Enums.CheckoutUserLoginType */
export enum ECheckoutUserLoginType {
  email = 1,
  phone = 2,
  social = 3
}

/** Roller.Core.Domain.Enums.CheckoutUserIdentityProvider */
export enum ECheckoutUserIdentityProvider {
  google = 1,
  facebook = 2,
  microsoft = 3,
  apple = 4
}

/** Internal use - used for auth uuid component buttons options */
export interface IAuthUUIDOptions {
  fontSize: TSize;
  buttonId: string;
  labelTranslationKey: string;
  icon?: string;
  value: ECheckoutUserLoginType;
  selected: boolean;
}

export enum EVerificationType {
  email = 'email',
  mobile = 'mobile'
}

/** VerifyCodeDTO - Payload when submitting login and signup verification requests */
export interface IGuestAuthVerifyCodeDTO {
  code: string;
  type: EVerificationType;
  newValue?: string;
}

/** For sharing common URL's between components that can be verified in Unit Tests */
export enum EAuthEndpoints {
  logout = '/checkout/user/details/logout'
}
